import * as React from "react";
import { styled } from "@mui/material";
import { QualifierFragment } from "fe-common/graphql";
import { MeasurementUnitsToString } from "patient/src/utils/dataHelpers";
import { PatientColorMap } from "../../../../../layout/patientColorMap";
import { useTranslate } from "patient/src/hooks/useTranslate";

//region [[ Styles ]]

const UnitEndAdornmentView = styled("div")({
  display: "flex",
  flexFlow: "row",
  justifyContent: "flex-end",
  alignItems: "flex-end",
  color: PatientColorMap.Default,
  fontSize: "14px",
  fontWeight: 600,
  width: "100%",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface UnitEndAdornmentProps {
  range: QualifierFragment[];
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const UnitEndAdornment = ({ ...props }: UnitEndAdornmentProps) => {
  const { translate } = useTranslate();
  const units = props.range?.find((r) => r.range?.complexUnits)?.range
    .complexUnits || {
    numerator: [props.range?.find((r) => r.range?.units)?.range?.units],
    denominator: null,
  };

  if (
    !units ||
    (!units?.denominator?.filter?.((i) => i)?.length &&
      !units?.numerator?.filter?.((i) => i)?.length)
  )
    return null;

  return (
    <UnitEndAdornmentView>
      {`(
        ${units.numerator
          .map?.((u) => MeasurementUnitsToString(u, translate))
          .join?.("")}
        ${!!units.denominator?.length ? "/" : ""}
        ${units.denominator
          ?.map?.((u) => MeasurementUnitsToString(u, translate))
          .join?.("")}
      )`}
    </UnitEndAdornmentView>
  );
};
